import FtService from "../../service/FtService";
// import this.$swal from 'sweetalert'
// import Swal from 'sweetalert2';

//export const namespaced = true

export const state = {
    transactions: [],
    singletrans: [],
    accountoption: [],
    tranSummary: [],
    formatter: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'NGN',
    }),
    declineloader: false,
    authloading: false,
    deleteloader: false,
    cards: [
        {
            id: 0,
            name: 'Total Amount',
            number: 'NGN 0.00',
            color: 'bg-gray-500'
        },
        {
            id: 1,
            name: 'Total Count',
            number: '0',
            color: 'bg-indigo'
        },
        {
            id: 2,
            name: 'Total Validated',
            number: '0%',
            color: 'bg-success'
        },
        {
            id: 3,
            name: 'Total Successful',
            number: '0',
            color: 'bg-black-6'
        }
    ],
    cardsold: [
        {
            id: 0,
            name: 'Total Amount',
            number: 'NGN 0.00',
            color: 'bg-primary'
        },
        {
            id: 1,
            name: 'Total Count',
            number: '0',
            color: 'bg-orange'
        },
        {
            id: 2,
            name: 'Total Validated',
            number: '0%',
            color: 'bg-success'
        },
        {
            id: 3,
            name: 'Total Successful',
            number: '0',
            color: 'bg-black-8'
        }
    ],
    batchcard: [
        {
            name: 'Total Amount',
            number: 'NGN 0.00',
        },
        {
            name: 'Total Count',
            number: '0',
        },
        {
            name: 'Date Processed',
            number: '0%',
        },
        {
            name: 'Status',
            number: '0',
        }

    ],
    batches: [],
    batchDetails: {
        account: "",
        authcount: 0,
        batchid: 0,
        date: "2020-05-06T10:38:05.376+0000",
        name: "Demo 6269",
        progress: "0",
        responsecode: "00",
        responsemessage: "Successful",
        source: "Upload",
        status: "completed",
        totalamount: 0,
        totalfailed: 0,
        totalsuccess: 0,
        transcount: 0
    },
    batchNumber: '',
    ftLoading: false,
    response: {},
    accounts: [],
    bankloading: false,
    banklist: [],
    currbank: {},
    batchLoading: false


};


export const getters = {};


export const mutations = {

    UPDATE_TRANSACTIONS: (state, payload) => {
        // console.log('Entered Mutation', payload);
        // console.log(payload);
        state.transactions = payload
    },

    updateFtLoading: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.ftLoading = payload
    },
    UPDATE_DECLINE_LOADER: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.declineloader = payload
    },
    REMOVE_SINGLE_TRANS: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.transactions = state.transactions.filter(
            trans => trans.creditaccount != payload
        )
    },
    UPDATE_SINGLE_TRANS: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.singletrans = payload
    },
    UPDATE_BATCH_DETAILS: (state, payload) => {
        state.batchDetails = payload

    },
    UPDATE_BANK_LIST: (state, payload) => {
        //console.log('Entered Mutation', payload);
        state.banklist = payload.map(bank => {
            const banks = {};
            banks.text = bank.bankname;
            banks['value'] = bank;
            return banks;
        });
    },
    UPDATE_BANK_LOADING: (state, payload) => {
        console.log('Entered Mutation', payload);
        state.bankloading = payload
    },
    UPDATE_CURR_BANK: (state, payload) => {
        console.log('Entered Mutation', payload);
        state.currbank = payload
    },
    UPDATE_AUTH_LOADING: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.authloading = payload
    },
    UPDATE_DELETE_LOADING: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.deleteloader = payload
    },
    updateBatchLoading: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.batchLoading = payload
    },
    updateBatches: (state, payload) => {
        state.batches = payload
    },
    updateResponse: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.response = payload
    },
    updateTranSummary: (state, payload) => {
        // console.log('Entered Mutation', payload);
        const result = [];
        const map = new Map();
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'NGN',
        });
        for (const item of payload) {
            if (!map.has(item.tranotherpartybankname)) {
                map.set(item.tranotherpartybankname, true);    // set any value to Map
                result.push({
                    bankCode: item.tranotherpartybankcode,
                    bankName: item.tranotherpartybankname,
                    totalCount: payload.filter(d => d.tranotherpartybankname === item.tranotherpartybankname).length,
                    totalAmount: formatter.format(payload.filter(d => d.tranotherpartybankname === item.tranotherpartybankname).reduce(function (sum, tax) {
                        return sum + parseInt(tax.tranlcyamount);
                    }, 0))
                });
            }
        }
        state.tranSummary = result
    },
    updateCards: (state, payload) => {
        console.log('Entered Mutation', payload);
        state.cards = payload
    },
    updateBatchDetail: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.batchDetails = payload
    },
    updateBatchNumber: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.batchNumber = payload
    },

    updateBatchCard: (state, payload) => {
        // console.log("inbatch mutation", payload);
        state.batchcard = payload
    }


};


export const actions = {

    callTransferInit: ({commit}, payload) => {
        commit("updateFtLoading", true);
        return FtService.callSingleTransferInit(payload)
            .then(response => {
                commit("updateFtLoading", false);
                return response.data
            }).catch(error => {
                commit("updateFtLoading", false);
                console.log(error)
            })
    },
    uploadFt: ({commit}, payload) => {
        // console.log('initiated');
        // console.log(payload);
        commit("updateResponse", {});
        commit("updateFtLoading", true);
        return FtService.callUploadFtApi(payload)
            .then(response => {
                let responseData = response.data;
                // console.log(responseData);
                commit("updateFtLoading", false);
                commit("updateResponse", responseData);
                commit("updateBatchNumber", responseData.batchid);
                if (responseData.responsecode === '00') {
                    commit("updateCards", [
                        {
                            id: 0,
                            name: 'Total Amount',
                            number: state.formatter.format(responseData.totalamount),
                            color: 'bg-gray-500'
                        },
                        {
                            id: 1,
                            name: 'Total Count',
                            number: responseData.transcount,
                            color: 'bg-indigo'
                        },
                        {
                            id: 2,
                            name: 'Total Validated',
                            number: (responseData.totalsuccess / responseData.transcount) * 100 + '%',
                            color: 'bg-success'
                        },
                        {
                            id: 3,
                            name: 'Total Successful',
                            number: responseData.totalsuccess,
                            color: 'bg-black-6'
                        }
                    ])
                }
                return responseData;
            })
            // eslint-disable-next-line no-unused-vars
            .catch(error => {
                commit("updateFtLoading", false);
                console.log(error)
                // alert(error)
                // throw error;
            });
    },

    uploadSingleFt: ({commit}, payload) => {
        // console.log('initiated');
        // console.log(payload);
        commit("updateResponse", {});
        commit("updateFtLoading", true);
        return FtService.callSingleUploadFtApi(payload)
            .then(response => {
                let responseData = response.data;
                // console.log(responseData);
                commit("updateFtLoading", false);
                commit("updateResponse", responseData);
                commit("updateBatchNumber", responseData.batchid);
                if (responseData.responsecode === '00') {
                    commit("updateCards", [
                        {
                            id: 0,
                            name: 'Total Amount',
                            number: state.formatter.format(responseData.totalamount),
                            color: 'bg-gray-500'
                        },
                        {
                            id: 1,
                            name: 'Total Count',
                            number: responseData.transcount,
                            color: 'bg-indigo'
                        },
                        {
                            id: 2,
                            name: 'Total Validated',
                            number: (responseData.totalsuccess / responseData.transcount) * 100 + '%',
                            color: 'bg-success'
                        },
                        {
                            id: 3,
                            name: 'Total Successful',
                            number: responseData.totalsuccess,
                            color: 'bg-black-6'
                        }
                    ])
                }
                return responseData;
            })
            // eslint-disable-next-line no-unused-vars
            .catch(error => {
                commit("updateFtLoading", false);
                console.log(error)
                // alert(error)
                // throw error;
            });
    },

    readBatchStatus: ({commit}, payload) => {
        // console.log('initiated');
        commit("updateResponse", {});
        commit("updateFtLoading", true);
        return FtService.callGetBatchStatusApi(payload)
            .then(response => {
                let responseData = response.data;
                // console.log(response.data);
                // console.log("hello world");
                commit("updateFtLoading", false);
                commit("updateResponse", responseData);
                commit("updateBatchDetail", responseData);
                //commit("updateBatchNumber", responseData.batchid)
                if (responseData.responsecode === '00') {
                    commit("updateCards", [
                        {
                            id: 0,
                            name: 'Total Amount',
                            number: state.formatter.format(responseData.totalamount),
                            color: 'bg-gray-500'
                        },
                        {
                            id: 1,
                            name: 'Total Count',
                            number: responseData.transcount,
                            color: 'bg-indigo'
                        },
                        {
                            id: 2,
                            name: 'Total Validated',
                            number: (responseData.totalsuccess / responseData.transcount) * 100 + '%',
                            color: 'bg-success'
                        },
                        {
                            id: 3,
                            name: 'Total Successful',
                            number: responseData.totalsuccess,
                            color: 'bg-black-6'
                        }
                    ]);
                    return responseData
                }

            })
            // eslint-disable-next-line no-unused-vars
            .catch(error => {
                commit("updateFtLoading", false)
                // console.log(error)
                // alert(error)
                // throw error;
            });
    },

    readAllBatches: ({commit}, payload) => {
        // console.log('in batches action');
        if (state.batches.length < 1)
            commit("updateBatchLoading", true);
        return FtService.callAllBatches(payload).then(response => {
            let responseData = response.data;
            // console.log(response.data);
            commit("updateBatchLoading", false);
            if (responseData.responsecode === "00")
                commit("updateBatches", responseData.data);
            return responseData;
        }).catch(error => {
            commit("updateBatchLoading", false);
            console.log(error)
        })
    },
    callAuthorizeTransaction: ({commit}, payload) => {
        // console.log('initiated');
        commit("updateFtLoading", true);
        return FtService.callAuthorizeTransaction(payload)
            .then(response => {
                commit("updateFtLoading", false);
                return response.data;
            }).catch(
                error => {
                    return error;
                }
            )
    },
    callDeclineTransaction: ({commit}, payload) => {
        // console.log('initiated');
        commit("UPDATE_DECLINE_LOADER", true);
        return FtService.callDeclineTransactionBatch(payload)
            .then(response => {
                commit("UPDATE_DECLINE_LOADER", false);
                return response.data;
            }).catch(
                error => {
                    return error;
                }
            )
    },


    queueBatch: ({commit}, payload) => {
        commit("UPDATE_AUTH_LOADING", true);
        return FtService.callPushBatchQueue(payload)
            .then(response => {
                let responseData = response.data;
                commit("UPDATE_AUTH_LOADING", false);
                const details = {
                    account: "",
                    authcount: 0,
                    batchid: 0,
                    date: "2020-05-06T10:38:05.376+0000",
                    name: "Demo 6269",
                    progress: "0",
                    responsecode: "00",
                    responsemessage: "Successful",
                    source: "Upload",
                    status: "completed",
                    totalamount: 0,
                    totalfailed: 0,
                    totalsuccess: 0,
                    transcount: 0
                };
                commit("UPDATE_BATCH_DETAILS", details);
                return responseData
            }).catch(
                error => {
                    commit("UPDATE_AUTH_LOADING", false);
                    return error
                }
            )
    },

    banklist: ({commit}, payload) => {
        commit("UPDATE_BANK_LOADING", true);
        return FtService.callBankListAPI(payload)
            .then(response => {
                let responseData = response.data;
                commit("UPDATE_BANK_LOADING", false);
                commit("UPDATE_BANK_LIST", responseData.banklist);
                return responseData
            }).catch(
                error => {
                    commit("UPDATE_BANK_LOADING", false);
                    return error.body
                }
            )
    },

    donameenquiry: ({commit}, payload) => {
        commit("UPDATE_BANK_LOADING", true);
        return FtService.callNameEnquiry(payload)
            .then(response => {
                let responseData = response.data;
                console.log(responseData);
                commit("UPDATE_BANK_LOADING", false);
                return responseData
            }).catch(
                error => {
                    commit("UPDATE_BANK_LOADING", false);
                    return error.message
                }
            )
    },
    singleft: ({commit}, payload) => {
        commit("updateFtLoading", true);
        return FtService.callSingleft(payload)
            .then(response => {
                let responseData = response.data;
                commit("updateFtLoading", false);
                return responseData
            }).catch(
                error => {
                    commit("updateFtLoading", false);
                    return error.message
                }
            )
    },



    deleteTransaction: ({commit}, payload) => {
        commit("UPDATE_DELETE_LOADING", true);
        return FtService.callDeleteTransactionAPI(payload)
            .then(response => {
                let responseData = response.data;
                commit("UPDATE_DELETE_LOADING", false);
                return responseData
            }).catch(
                error => {
                    commit("UPDATE_DELETE_LOADING", false);
                    return error
                }
            )
    },

    readBatchTransactions: ({commit}, payload) => {
        // console.log('initiated')
        commit("updateResponse", {});
        commit("updateFtLoading", true);
        return FtService.callGetBatchTransactionApi(payload)
            .then(response => {
                let responseData = response.data;
                // console.log(response.data);
                commit("updateFtLoading", false);
                commit("updateResponse", responseData);
                //commit("updateBatchNumber", responseData.batchref)
                //commit("updateBatchNumber", responseData.batchref)
                if (responseData.responsecode === '00') {
                    // console.log(responseData)
                    commit("UPDATE_SINGLE_TRANS", responseData.trasactions);
                    commit("updateTranSummary", responseData.trasactions)
                }

                return responseData;

            })
            // eslint-disable-next-line no-unused-vars
            .catch(error => {
                commit("updateFtLoading", false)
                console.log(error)
                // alert(error)
                // throw error;
            });
    }
}
